import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
  NgbAccordionBody,
  NgbAccordionButton,
  NgbAccordionCollapse,
  NgbAccordionDirective,
  NgbAccordionHeader,
  NgbAccordionItem,
} from '@ng-bootstrap/ng-bootstrap';
import { SafeHtmlPipe } from '@mwe/ui/pipes';
import { AccordionItem } from '@mwe/models';

@Component({
  selector: 'mwe-accordion-component',
  imports: [
    NgbAccordionDirective,
    NgbAccordionItem,
    NgbAccordionHeader,
    NgbAccordionCollapse,
    NgbAccordionBody,
    NgbAccordionButton,
    SafeHtmlPipe,
  ],
  templateUrl: './accordion-component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionComponent {
  items = input.required<AccordionItem[]>();
}
